<template>
  <div
    ref="parallaxContainerRef"
    v-editable="blok"
    class="ProductListWithImage"
    :class="[desktopWidth('full'), blockPaddingTop('md'), blockPaddingBottom('md')]"
  >
    <!-- Mobile -->
    <div
      v-if="uiStore.isMobile"
      :class="{
        'flex gap-2': products.length <= 1,
      }"
    >
      <div
        v-if="blok.imageOrVideo && blok.imageOrVideo.filename"
        class="w-full mb-4 overflow-hidden"
        :class="{
          'aspect-square': blok.ratioMobile === 'square'
        }"
      >
        <video
          v-if="checkIfVideoFile(blok.imageOrVideo.filename)"
          :style="blok.parallaxEffect ? { transform: `translateY(${offset}px) scale(1.2)`, transformOrigin: 'bottom center' } : {}"
          class="w-full mb-4 transition-transform duration-[50ms]"
          :class="[blok.imagePosition, {
            'h-full object-cover': blok.ratioMobile === 'square'
          }]"
          loop
          muted
          autoplay
          playsinline
          controls
        >
          <source :src="blok.imageOrVideo.filename" type="video/mp4">
        </video>

        <nuxt-img
          v-else
          :src="blok.imageOrVideo.filename"
          :alt="blok.imageOrVideo?.alt || ''"
          class="w-full h-full object-cover mb-4 transition-transform duration-[50ms]"
          :style="blok.parallaxEffect ? { transform: `translateY(${offset}px) scale(1.2)`, transformOrigin: 'bottom center' } : {}"
          :class="[blok.imagePosition, {
            'h-full object-cover': blok.ratioMobile !== 'square'
          }]"
          preset="standard"
          loading="lazy"
          sizes="mob375:100vw mob390:100vw mob414:100vw desk:1260px"
        />
      </div>

      <!--
      <QuickBuy
        v-if="products.length === 1"
        :manual-product="products[0]"
        :additional-image="blok.imageOrVideo && blok.imageOrVideo.filename ? {
          file: blok.imageOrVideo.filename,
          imagePosition: blok.imagePosition
        } : null"
      />
      -->

      <component
        :is="blok.mobileDesign === 'swiper' && products.length > 2 ? Swiper:'div'"
        class="w-full"
        :class="{
          'grid grid-cols-2 gap-4': blok.mobileDesign !== 'swiper' && products.length > 1,
          'grid grid-cols-1 gap-4': blok.mobileDesign !== 'swiper' && products.length <= 1
        }"
        :space-between="4"
        :slides-per-view="2.1"
        :modules="[SwiperPagination]"
        :pagination="{
          dynamicBullets: true,
          clickable: false,
        }"
      >
        <component
          :is="blok.mobileDesign === 'swiper' ? SwiperSlide:'div'"
          v-for="(product) in products"
          :key="product.partNo"
        >
          <ProductCard
            :product="product"
            :enable-quick-buy="false"
            design="standard"
            :placement="100"
          />
        </component>
      </component>
    </div>
    <!-- * * * * * * * * * * * * DESKTOP -->
    <div
      v-else
      class="desk:layout-container w-full grid grid-cols-12 gap-12 tabletPortraitOnly:block"
    >
      <div
        class="min-h-410"
        :class="{
          'col-span-8': products.length <= 1,
          'col-span-6': products.length === 2,
          'col-span-5': products.length === 3 || products.length >= 5,
          'col-span-7': products.length === 4,
        }"
        :style="imageStyle"
      >
        <div
          class="relative h-full w-full overflow-hidden"
          :class="{
            'aspect-square': blok.ratio === 'square',
            'aspect-auto': blok.ratio === 'fit',
          }"
        >
          <div
            v-if="blok.imageOrVideo && blok.imageOrVideo.filename && checkIfVideoFile(blok.imageOrVideo.filename)"
            class="absolute w-full h-full"
          >
            <video
              class="w-full h-full object-cover transition-transform duration-[50ms]"
              :style="blok.parallaxEffect ? { transform: `translateY(${offset}px) scale(1.2)`, transformOrigin: 'bottom center' } : {}"
              :class="blok.imagePosition"
              loop
              muted
              autoplay
              playsinline
              controls
            >
              <source :src="blok.imageOrVideo.filename" type="video/mp4">
            </video>
          </div>
          <div
            v-else-if="blok.imageOrVideo && blok.imageOrVideo.filename"
            class="absolute h-full w-full"
          >
            <nuxt-img
              :style="blok.parallaxEffect ? { transform: `translateY(${offset}px) scale(1.2)`, transformOrigin: 'bottom center' } : {}"
              :src="blok.imageOrVideo.filename"
              :alt="blok.imageOrVideo?.alt || ''"
              class="w-full h-full object-cover transition-transform duration-[50ms]"
              :class="blok.imagePosition"
              preset="standard"
              loading="lazy"
              sizes="mob375:100vw mob390:100vw mob414:100vw desk:1260px"
            />
          </div>
          <div v-else><!-- no image --></div>
        </div>
      </div>
      <div
        class="grid gap-12"
        :class="{
          'col-span-4': products.length <= 1,
          'col-span-6 grid-cols-2': products.length === 2,
          'col-span-7 grid-cols-3': products.length === 3 || products.length >= 5,
          'col-span-5 grid-cols-2': products.length === 4,
        }"
      >
        <!-- Quickbuy variant Set v-else on Product Card
        <div v-if="products.length === 1">
          <QuickBuy
            :manual-product="products[0]"
            :manual-width="428"
            :additional-image="blok.imageOrVideo && blok.imageOrVideo.filename ? {
              file: blok.imageOrVideo.filename,
              imagePosition: blok.imagePosition
            } : null"
          />
        </div>
        -->

        <ProductCard
          v-for="(product) in products"
          :key="product.partNo"
          :class="{
            'first:-mb-32 last:-mb-32': products.length === 2,
            'first:-mb-32 even:-mb-32 last:-mb-32': products.length === 3,
            'odd:-mb-32 last:-mb-32': products.length === 4,
            'first:pb-32 even:-mb-32 odd:-mb-32 last:-mb-32': products.length === 5 || products.length >= 6,
          }"
          :product="product"
          :enable-quick-buy="false"
          design="standard"
          :placement="100"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  DatasourceObjectPosition,
  ProductSelector, StoryBlokAsset,
  StoryBlokPropBase
} from '~/constants/types/storyblok';
import useVisualAppearancePlugin from '~/composeables/useVisualAppearancePlugin';
import { computed, ref, watch } from 'vue';
import useStoryblokAdmin from '~/composeables/useStoryblokAdmin';
import useAlgoliaFetch from '~/composeables/useAlgoliaFetch';
import { useUiStore } from '~/store/ui';
import ProductCard from '~/components/product/ProductCard.vue';

import { checkIfVideoFile, convertObjectPositionToBgPosition, storyblokScaleImage } from '~/util/imageUtil';
import QuickBuy from '~/components/product/QuickBuy.vue';
import { ProductModel } from '~/models/product';
import { useElementBounding } from '@vueuse/core';
import useStructuredData from '~/composeables/useStructuredData';

const { isInStoryblokAdmin } = useStoryblokAdmin();
const { getProductsByUrl, convertRawToProducts } = useAlgoliaFetch();

const uiStore = useUiStore();

const Swiper = resolveComponent('Swiper');
const SwiperSlide = resolveComponent('SwiperSlide');

type Props = StoryBlokPropBase & {
  products: ProductSelector[]; // 1-6
  imageOrVideo: StoryBlokAsset;
  ratio: '' | 'fit' | 'square';
  ratioMobile: '' | 'fit' | 'square';
  mobileDesign: '' | 'grid' | 'swiper';
  imagePosition: DatasourceObjectPosition;
  parallaxEffect: boolean;
}
const props = defineProps<{
  blok: Props
}>();

const { desktopWidth, blockPaddingTop, blockPaddingBottom } = useVisualAppearancePlugin(props);

const imageStyle = computed(()=> {
  if (props.blok.imageOrVideo && props.blok.imageOrVideo.filename
      && !checkIfVideoFile(props.blok.imageOrVideo.filename)
      && props.blok.ratio !== 'square') {

    const url = storyblokScaleImage(props.blok.imageOrVideo.filename, 758);

    return {
      backgroundImage: `url(${url})`,
      backgroundSize: 'cover',
      backgroundPosition: convertObjectPositionToBgPosition(props.blok.imagePosition),
    };
  }
  return {};
});

const productsPartNo = computed(()=> {
  return props.blok.products.filter((f)=> f.product !== '').map((m) => m.product.product.url).filter((f) => f !== '');
});

const products = ref<ProductModel[]>([]);
const getProducts = async() => {
  if (productsPartNo.value.length) {
    const res = await getProductsByUrl(productsPartNo.value);
    if (res) {
      const splitProducts = convertRawToProducts(res.hits);
      products.value = splitProducts.map((m) => m.product);
    } else {
      console.log('@todo handle error');
    }
  } else {
    products.value = [];
  }
};
await getProducts();

if (isInStoryblokAdmin()) {
  watch(() => props.blok.products, async() => {
    await getProducts();
  });
}

const { buildItemListJsonLd } = useStructuredData();
useJsonld(buildItemListJsonLd(products.value, 'ProductListWithImage'));

const parallaxContainerRef = useTemplateRef('parallaxContainerRef');
const { top } = useElementBounding(parallaxContainerRef);

const windowHeight = ref(0);
onMounted(()=> {
  windowHeight.value = window.innerHeight;
});

const progress = computed(() => {
  const start = windowHeight.value;
  const end = -600;
  return Math.max(0, Math.min((start - top.value) / (start - end), 1));
});

const offset = computed(() => progress.value * 140);

</script>

<style lang="postcss">
</style>
